import type { VariantProps } from "class-variance-authority"
import { Link, type LinkProps } from "react-router"

import { buttonVariants } from "@/components/ui/button"
import { cn } from "@/lib/utils"

/** Navigation styled as a button — keeps real link semantics (role=link, middle-click, etc.). */
export function LinkButton({ variant, size, className, ...props }: LinkProps & VariantProps<typeof buttonVariants>) {
  return <Link data-slot="button" className={cn(buttonVariants({ variant, size }), className)} {...props} />
}
